export { default } from "./KnowWonderLearnChart";
